import { Language } from "@/hooks/use-browser-language";

export const socialSellingLandingTranslations = {
  pl: {
    // Hero badges
    badgeBeta: "🚀 BETA - Za darmo do odwołania",
    badgeCompetitors: "✓ Analiza 1-3 konkurentów",
    badgeMetrics: "✓ 15+ metryk Social Selling",
    badgeReport: "✓ Raport w 48h",
    
    // Hero
    heroTitle1: "Audyt Social Selling.",
    heroTitle2: "Kto wygrywa na LinkedIn?",
    heroTitle3: "Ty czy Twoja konkurencja?",
    heroDescription: "Analizujemy Twoją firmę, pracowników i 1-3 konkurentów. Sprawdzamy 15+ metryk Social Sellingu i dostarczamy benchmark branżowy w 48h.",
    heroBetaNote: "W fazie Beta – całkowicie bezpłatnie.",
    heroCta: "Zamów bezpłatny audyt (Beta)",
    heroFeature1: "Szybki formularz",
    heroFeature2: "Dane chronione",
    heroFeature3: "Raport na email",
    heroTrust: "Zaufało nam ponad 100+ firm",
    
    // Problem section
    problemTitle: "Czy tracisz klientów przez nieefektywny social selling?",
    problem1Title: "Brak leadów z LinkedIn",
    problem1Desc: "Twoi sprzedawcy nie generują leadów z największej sieci B2B",
    problem2Title: "Konkurencja Cię wyprzedza",
    problem2Desc: "Twoi konkurenci zyskują klientów, których tracisz",
    problem3Title: "Słaby personal branding",
    problem3Desc: "Profile Twoich pracowników nie budują zaufania",
    problem4Title: "Brak strategii",
    problem4Desc: "Nie wiesz od czego zacząć z LinkedIn i social sellingiem",
    problemStat: "kupujących B2B sprawdza profile sprzedawców na LinkedIn przed rozmową",
    problemSource: "Źródło: LinkedIn Sales Solutions, 2024",
    
    // Solution section
    solutionTitle: "8 obszarów kompleksowej analizy",
    solutionSubtitle: "Otrzymaj szczegółowy raport z analizą i konkretnymi krokami do działania",
    
    // Cards
    card1Title: "Executive Summary",
    card1Desc: "Profil firmy, kluczowe metryki, pozycjonowanie vs konkurencja. Analiza mocnych stron i możliwości rozwoju z SWOT.",
    card2Title: "Analiza Konkurencyjna",
    card2Desc: "Porównanie z 1-3 konkurentami: aktywność liderów, % aktywnych pracowników, częstotliwość postowania, średnie zaangażowanie.",
    card3Title: "LinkedIn Benchmark",
    card3Desc: "Obserwujący na pracownika, ranking obecności na rynku, gęstość obserwujących. Tabele porównawcze z pozycją w branży.",
    card4Title: "Leadership Correlation",
    card4Desc: "Jak aktywność liderów (C-Level, VP, Director) wpływa na wyniki firmy na LinkedIn – analiza korelacji zaangażowania.",
    card5Title: "Viral Content Showcase",
    card5Desc: "Najpopularniejsze posty Twojej firmy i pracowników. Identyfikacja treści o największym zasięgu i zaangażowaniu.",
    card6Title: "Employee Insights",
    card6Desc: "Struktura organizacyjna (C-Level, VP, Sales, Inne), poziomy aktywności, najlepsi wykonawcy i leaderboard wpływu.",
    card7Title: "Content Strategy",
    card7Desc: "Wydajność postów, typy treści (tekst/obraz/wideo), ROI firmowy vs pracowniczy, tematyka i trendy publikacji.",
    card8Title: "Social Selling Snapshot",
    card8Desc: "Kluczowe metryki w jednym miejscu, najlepsi dyrektorzy, podział organizacyjny i konkretny plan działania 30/60/90.",
    
    // CTA card
    ctaCardTitle: "Zamów bezpłatny audyt",
    ctaCardDesc: "Rozpocznij analizę swojej firmy już teraz. W fazie Beta – całkowicie za darmo!",
    ctaCardButton: "Rozpocznij audyt",
    
    // How it works
    howTitle: "Jak to działa?",
    howSubtitle: "Prosty proces w 3 krokach",
    step1Title: "Wypełnij formularz",
    step1Time: "2 minuty",
    step1Desc: "Podaj swoją domenę i opcjonalnie domeny konkurencji",
    step1Sub: "Uzupełnij dane kontaktowe",
    step2Title: "Czekaj na analizę",
    step2Time: "24-48 godzin",
    step2Desc: "Nasi eksperci przeprowadzą szczegółowy audyt Twojego social sellingu",
    step2Sub: "Przeanalizujemy Twoją firmę i konkurencję",
    step3Title: "Otrzymaj raport",
    step3Time: "email",
    step3Desc: "Szczegółowy raport PDF z analizą i planem działania",
    step3Sub: "Konkretne rekomendacje dopasowane do Twojej branży",
    
    // Report preview
    reportTitle: "Co znajdziesz w raporcie?",
    reportItem1: "📊 Executive Summary - Profil firmy, kluczowe metryki, mocne strony i SWOT",
    reportItem2: "🔍 Competitive Analysis - Porównanie z 1-3 konkurentami: liderzy, pracownicy, posty",
    reportItem3: "📈 LinkedIn Benchmark - Obserwujący/pracownik, ranking w branży, tabele porównawcze",
    reportItem4: "🔗 Leadership Correlation - Wpływ aktywności liderów na wyniki całej firmy",
    reportItem5: "📸 Viral Content - Najpopularniejsze posty i treści o największym zasięgu",
    reportItem6: "👥 Employee Insights - Struktura organizacyjna, aktywność i leaderboard wpływu",
    reportItem7: "📝 Content Strategy - Analiza typów treści, ROI i trendy publikacji",
    reportItem8: "⚠️ Jakość danych - Ostrzeżenia o pokryciu danymi i rekomendacje uzupełnień",
    reportItem9: "✅ Action Plan - Quick wins, priorytety i plan 30/60/90 dni",
    
    // Social Proof
    socialProofTitle: "Co mówią firmy, które już sprawdziły swój audyt",
    testimonial1Quote: "Dowiedzieliśmy się, że tylko 23% naszych handlowców jest aktywnych na LinkedIn vs 67% u konkurencji. Teraz wiemy gdzie działać.",
    testimonial1Role: "Head of Sales",
    testimonial2Quote: "Leadership Correlation pokazał, że firmy gdzie CEO postuje regularnie mają 3x więcej obserwujących. Nasz szef zaczął pisać.",
    testimonial2Role: "CMO",
    testimonial3Quote: "Mieliśmy 45 obserwujących na pracownika vs 120 u lidera branży. Benchmark otworzył nam oczy na skalę problemu.",
    testimonial3Role: "CEO",
    
    // Stats
    statsTitle: "Dlaczego social selling działa?",
    stat1Desc: "kupujących sprawdza profil sprzedawcy przed rozmową",
    stat2Desc: "większe szanse na osiągnięcie kwoty sprzedażowej",
    stat3Desc: "więcej okazji sprzedażowych w pipeline",
    stat4Desc: "więcej potencjalnych klientów miesięcznie",
    statsSource: "Źródło: LinkedIn Sales Solutions, Sopro.io, Sprout Social 2024-2025",
    
    // FAQ
    faqTitle: "Najczęściej zadawane pytania",
    faq1Q: "Ile kosztuje audyt?",
    faq1A: "Narzędzie jest obecnie w fazie Beta i całkowicie bezpłatne – do odwołania. Po zakończeniu fazy testów planujemy wprowadzić płatne wersje. Teraz to najlepszy moment, by skorzystać za darmo!",
    faq2Q: "Ile firm/konkurentów analizujecie?",
    faq2A: "W fazie Beta analizujemy Twoją firmę oraz 1-3 konkurentów. Możesz podać ich domeny samodzielnie lub zostawić pole puste – wtedy sami znajdziemy głównych graczy w Twojej branży.",
    faq3Q: "Co dokładnie mierzycie?",
    faq3A: "Analizujemy 15+ metryk: dane firmowe (obserwujący, aktywność postów, zaangażowanie), dane pracowników (struktura, poziomy aktywności, top performers), wydajność treści (typy, ROI, tematyka) oraz korelacje liderów. Wszystko w porównaniu z konkurencją.",
    faq4Q: "Czy analizujecie też moich pracowników?",
    faq4A: "Tak! Analizujemy profile pracowników z LinkedIn: stanowiska, poziomy organizacyjne (C-Level, VP, Director, Sales), aktywność publikowania, średnie zaangażowanie. Identyfikujemy też Twoich najlepszych 'ambasadorów' i porównujemy z konkurencją.",
    faq5Q: "Jak długo czekam na raport?",
    faq5A: "Raport otrzymasz w ciągu 24-48 godzin roboczych na podany adres email.",
    faq6Q: "Co jeśli nie znam swojej konkurencji?",
    faq6A: "Nie ma problemu! Możesz zostawić pole konkurencji puste, a my znajdziemy głównych konkurentów w Twojej branży i domenie.",
    faq7Q: "Czy muszę mieć LinkedIn Premium?",
    faq7A: "Nie. Audytujemy publicznie dostępne dane z LinkedIn. Nie potrzebujesz żadnego specjalnego konta.",
    faq8Q: "Co zrobicie z moimi danymi?",
    faq8A: "Twoje dane są w 100% bezpieczne i chronione zgodnie z RODO. Używamy ich wyłącznie do przygotowania raportu.",
    faq9Q: "Czy to wiąże się z jakimś zobowiązaniem?",
    faq9A: "Nie. W fazie Beta narzędzie jest bezpłatne i nie wiąże się z żadnym zobowiązaniem. Po otrzymaniu raportu sam decydujesz, co dalej.",
    faq10Q: "Dla jakich firm jest ten audyt?",
    faq10A: "Audyt jest dedykowany dla firm B2B z minimum 5 pracownikami, które chcą rozwijać sprzedaż przez LinkedIn i social selling.",
    
    // Final CTA
    finalCtaTitle: "Gotowy na zwiększenie sprzedaży przez LinkedIn?",
    finalCtaSubtitle: "Skorzystaj teraz, póki narzędzie jest bezpłatne. Po fazie Beta audyt będzie płatny.",
    finalCtaButton: "Zamów bezpłatny audyt (Beta)",
    finalFeature1: "Bez karty kredytowej",
    finalFeature2: "Bez zobowiązań",
    finalFeature3: "Raport w 48h",
    
    // Footer
    footerCopyright: "© 2025 Lifactor. Wszelkie prawa zastrzeżone.",
    footerPrivacy: "Polityka prywatności",
    footerTerms: "Regulamin",
  },
  en: {
    // Hero badges
    badgeBeta: "🚀 BETA - Free until further notice",
    badgeCompetitors: "✓ 1-3 competitor analysis",
    badgeMetrics: "✓ 15+ Social Selling metrics",
    badgeReport: "✓ Report in 48h",
    
    // Hero
    heroTitle1: "Social Selling Audit.",
    heroTitle2: "Who's winning on LinkedIn?",
    heroTitle3: "You or your competition?",
    heroDescription: "We analyze your company, employees, and 1-3 competitors. We check 15+ Social Selling metrics and deliver an industry benchmark in 48h.",
    heroBetaNote: "In Beta phase – completely free.",
    heroCta: "Order free audit (Beta)",
    heroFeature1: "Quick form",
    heroFeature2: "Data protected",
    heroFeature3: "Report via email",
    heroTrust: "Trusted by 100+ companies",
    
    // Problem section
    problemTitle: "Are you losing customers due to ineffective social selling?",
    problem1Title: "No leads from LinkedIn",
    problem1Desc: "Your salespeople don't generate leads from the largest B2B network",
    problem2Title: "Competition is ahead",
    problem2Desc: "Your competitors are gaining customers you're losing",
    problem3Title: "Weak personal branding",
    problem3Desc: "Your employees' profiles don't build trust",
    problem4Title: "No strategy",
    problem4Desc: "You don't know where to start with LinkedIn and social selling",
    problemStat: "of B2B buyers check salespeople's LinkedIn profiles before a conversation",
    problemSource: "Source: LinkedIn Sales Solutions, 2024",
    
    // Solution section
    solutionTitle: "8 areas of comprehensive analysis",
    solutionSubtitle: "Get a detailed report with analysis and actionable steps",
    
    // Cards
    card1Title: "Executive Summary",
    card1Desc: "Company profile, key metrics, positioning vs competition. Analysis of strengths and growth opportunities with SWOT.",
    card2Title: "Competitive Analysis",
    card2Desc: "Comparison with 1-3 competitors: leader activity, % of active employees, posting frequency, average engagement.",
    card3Title: "LinkedIn Benchmark",
    card3Desc: "Followers per employee, market presence ranking, follower density. Comparative tables with industry position.",
    card4Title: "Leadership Correlation",
    card4Desc: "How leader activity (C-Level, VP, Director) affects company results on LinkedIn – engagement correlation analysis.",
    card5Title: "Viral Content Showcase",
    card5Desc: "Most popular posts from your company and employees. Identification of content with the highest reach and engagement.",
    card6Title: "Employee Insights",
    card6Desc: "Organizational structure (C-Level, VP, Sales, Other), activity levels, top performers and influence leaderboard.",
    card7Title: "Content Strategy",
    card7Desc: "Post performance, content types (text/image/video), company vs employee ROI, topics and publication trends.",
    card8Title: "Social Selling Snapshot",
    card8Desc: "Key metrics in one place, top executives, organizational breakdown and concrete 30/60/90 action plan.",
    
    // CTA card
    ctaCardTitle: "Order free audit",
    ctaCardDesc: "Start analyzing your company now. In Beta phase – completely free!",
    ctaCardButton: "Start audit",
    
    // How it works
    howTitle: "How does it work?",
    howSubtitle: "Simple 3-step process",
    step1Title: "Fill out the form",
    step1Time: "2 minutes",
    step1Desc: "Enter your domain and optionally competitor domains",
    step1Sub: "Complete your contact details",
    step2Title: "Wait for analysis",
    step2Time: "24-48 hours",
    step2Desc: "Our experts will conduct a detailed audit of your social selling",
    step2Sub: "We'll analyze your company and competition",
    step3Title: "Receive report",
    step3Time: "email",
    step3Desc: "Detailed PDF report with analysis and action plan",
    step3Sub: "Specific recommendations tailored to your industry",
    
    // Report preview
    reportTitle: "What will you find in the report?",
    reportItem1: "📊 Executive Summary - Company profile, key metrics, strengths and SWOT",
    reportItem2: "🔍 Competitive Analysis - Comparison with 1-3 competitors: leaders, employees, posts",
    reportItem3: "📈 LinkedIn Benchmark - Followers/employee, industry ranking, comparative tables",
    reportItem4: "🔗 Leadership Correlation - Impact of leader activity on overall company results",
    reportItem5: "📸 Viral Content - Most popular posts and content with highest reach",
    reportItem6: "👥 Employee Insights - Organizational structure, activity and influence leaderboard",
    reportItem7: "📝 Content Strategy - Content type analysis, ROI and publication trends",
    reportItem8: "⚠️ Data Quality - Data coverage warnings and recommendations",
    reportItem9: "✅ Action Plan - Quick wins, priorities and 30/60/90 day plan",
    
    // Social Proof
    socialProofTitle: "What companies say after their audit",
    testimonial1Quote: "We discovered that only 23% of our salespeople are active on LinkedIn vs 67% at the competition. Now we know where to act.",
    testimonial1Role: "Head of Sales",
    testimonial2Quote: "Leadership Correlation showed that companies where the CEO posts regularly have 3x more followers. Our boss started writing.",
    testimonial2Role: "CMO",
    testimonial3Quote: "We had 45 followers per employee vs 120 at the industry leader. The benchmark opened our eyes to the scale of the problem.",
    testimonial3Role: "CEO",
    
    // Stats
    statsTitle: "Why does social selling work?",
    stat1Desc: "of buyers check the seller's profile before a conversation",
    stat2Desc: "higher chances of achieving sales quota",
    stat3Desc: "more sales opportunities in the pipeline",
    stat4Desc: "more potential customers per month",
    statsSource: "Source: LinkedIn Sales Solutions, Sopro.io, Sprout Social 2024-2025",
    
    // FAQ
    faqTitle: "Frequently Asked Questions",
    faq1Q: "How much does the audit cost?",
    faq1A: "The tool is currently in Beta phase and completely free – until further notice. After testing ends, we plan to introduce paid versions. Now is the best time to use it for free!",
    faq2Q: "How many companies/competitors do you analyze?",
    faq2A: "In Beta phase, we analyze your company and 1-3 competitors. You can provide their domains yourself or leave the field empty – we'll find the main players in your industry.",
    faq3Q: "What exactly do you measure?",
    faq3A: "We analyze 15+ metrics: company data (followers, post activity, engagement), employee data (structure, activity levels, top performers), content performance (types, ROI, topics) and leader correlations. All compared to competition.",
    faq4Q: "Do you also analyze my employees?",
    faq4A: "Yes! We analyze employee profiles from LinkedIn: positions, organizational levels (C-Level, VP, Director, Sales), publishing activity, average engagement. We also identify your best 'ambassadors' and compare with competitors.",
    faq5Q: "How long do I wait for the report?",
    faq5A: "You'll receive the report within 24-48 business hours at the provided email address.",
    faq6Q: "What if I don't know my competitors?",
    faq6A: "No problem! You can leave the competitor field empty and we'll find the main competitors in your industry and domain.",
    faq7Q: "Do I need LinkedIn Premium?",
    faq7A: "No. We audit publicly available LinkedIn data. You don't need any special account.",
    faq8Q: "What will you do with my data?",
    faq8A: "Your data is 100% secure and protected in accordance with GDPR. We use it only to prepare the report.",
    faq9Q: "Does this involve any obligation?",
    faq9A: "No. In Beta phase, the tool is free and involves no obligation. After receiving the report, you decide what's next.",
    faq10Q: "What companies is this audit for?",
    faq10A: "The audit is dedicated to B2B companies with at least 5 employees who want to develop sales through LinkedIn and social selling.",
    
    // Final CTA
    finalCtaTitle: "Ready to increase sales through LinkedIn?",
    finalCtaSubtitle: "Use it now while the tool is free. After Beta, the audit will be paid.",
    finalCtaButton: "Order free audit (Beta)",
    finalFeature1: "No credit card required",
    finalFeature2: "No obligations",
    finalFeature3: "Report in 48h",
    
    // Footer
    footerCopyright: "© 2025 Lifactor. All rights reserved.",
    footerPrivacy: "Privacy Policy",
    footerTerms: "Terms of Service",
  }
};

export type LandingTranslationKey = keyof typeof socialSellingLandingTranslations.pl;

export function getLandingTranslation(lang: Language, key: LandingTranslationKey): string {
  return socialSellingLandingTranslations[lang][key] || socialSellingLandingTranslations.en[key];
}
